import './App.css';
import Covid from './components/Covid-Tracker/Covid'



function App() {
  return (
    <>
      <Covid/>
    </>
  );
}

export default App;
